import React from 'react';
import Footer from './Footer';
import LogoIcon from '../../svg/LogoIcon';

const GeneralLayout = ({ children }) => {
  return (
    <>
      <div className="flex w-64 mx-auto mt-10 pb-8 border-b">
        <LogoIcon />
      </div>
      <main className="text-gray-900">{children}</main>
      <Footer />
    </>
  );
};

export default GeneralLayout;
